/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Default_ErrorInputs */

const nl_auth_password_errors_default_error = /** @type {(inputs: Auth_Password_Errors_Default_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een fout opgetreden bij het valideren van het wachtwoord`)
};

/**

* @param {Auth_Password_Errors_Default_ErrorInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_default_error = /** @type {((inputs?: Auth_Password_Errors_Default_ErrorInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Default_ErrorInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_default_error(inputs)
});
export { auth_password_errors_default_error as "auth.password_errors.default_error" }